import { atom } from 'recoil';

export const channelTalkActiveStatusAtom = atom<boolean>({
  key: 'channelTalkActiveStatus',
  default: false,
});
